<template>
<div class="scrolling-inside-modal">
    <div class="modal fade" id="exampleModalScrollables" tabindex="-1" role="dialog"
        aria-labelledby="exampleModalScrollableTitles" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable  modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalScrollableTitles">Preview Letter
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" id="preview_letter_id" >
                        <!-- Dispute letter goes here -->
                        <section id="preview_view" v-if="letterContent">
                            <div class="row">
                                <div class="col-12">
                                    <div class="card">
                                        <div class="card-content">
                                            <div class="card-body" >
                                                <span v-html="letterContent.data.letter_preview"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                    </div>
                    <div class="modal-footer align-center">
                        <span v-html="letterBtnEdit"></span>
                        <button type="button" class="btn btn-primary"
                            data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
</div>
</template>
<script>
    import { useDisputeLetterStore } from '../../../stores/DisputeLetterStore.js'
    import {ref,watch} from 'vue'
    export default{
        setup(props){
            const disputeLetterStore = useDisputeLetterStore(),letterContent=ref(),letterBtnEdit=ref();
            watch(disputeLetterStore, async (newLetterStore, oldLetterStore) => {
                letterContent.value = newLetterStore.letterContentPreview;
                letterBtnEdit.value = newLetterStore.letterBtnEdit;
            })
            return {
                disputeLetterStore,
                letterContent,
                letterBtnEdit
            }
        },
        methods:{

        }
    }
</script>
